<template>
  <Incident />
</template>

<script>
import Incident from '../components/templates/Incident.vue'

export default {
  components: {
    Incident
  }
}
</script>
